import { render, staticRenderFns } from "./CalendarActivities.vue?vue&type=template&id=1728130b"
import script from "./CalendarActivities.vue?vue&type=script&lang=js"
export * from "./CalendarActivities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports